module.exports = __webpack_public_path__ + "img/nodata.83baf898.png";